import { useCallback } from 'react';
import { Box, Button } from '@material-ui/core';

import { Panel, Typography } from '@components';
import { content } from '@content';
import { func } from '@utils';

import { DataCardsProps } from './DataCards.props';
import { useStyles } from './DataCards.styles';
import { DataCardButtonType } from './DataCards.types';

export const DataCards = ({ className = '', items, onUpload, onConfig }: DataCardsProps): JSX.Element => {
  const styles = useStyles();

  const handleButtonClick = useCallback(
    (event) => {
      const { type, id } = event.currentTarget.dataset;
      const callback = (type as DataCardButtonType) === DataCardButtonType.upload ? onUpload : onConfig;

      if (callback) {
        callback(id);
      }
    },
    [onUpload, onConfig],
  );

  return (
    <Box className={className}>
      <Box className={styles.content}>
        {items.map((item) => (
          <Panel className={styles.item} key={item.id}>
            <Typography.Title className={styles.itemTitle} dangerouslySetInnerHTML={{ __html: item.title }} />
            {onUpload && item.upload && (
              <Button
                className={styles.itemButton}
                variant="contained"
                color="secondary"
                disabled={item.disabled}
                data-id={item.id}
                data-type={DataCardButtonType.upload}
                onClick={item.disabled ? func.nop : handleButtonClick}
              >
                {content.manualUpload}
              </Button>
            )}
            {onConfig && item.config && (
              <Button
                className={styles.itemButton}
                variant="outlined"
                color="secondary"
                disabled={item.disabled}
                data-id={item.id}
                data-type={DataCardButtonType.config}
                onClick={item.disabled ? func.nop : handleButtonClick}
              >
                {content.configureAutomatedFeed}
              </Button>
            )}
            {item.subtitle && <Typography.Caption className={styles.itemSubtitle}>{item.subtitle}</Typography.Caption>}
          </Panel>
        ))}
      </Box>
    </Box>
  );
};
